import { Filter } from "@mm-products/java-multima-framework";

export enum StorageKeyType {
    TAX_GURU_DOCUMENT_FILTER = "taxGuruDocumentFilter",
    TAX_GURU_ACTIVITY_FILTER = "taxGuruActivityFilter",
    TAX_GURU_CONTRACT_FILTER = "taxGuruContractFilter",
    TAX_GURU_CLIENT_FILTER = "taxGuruClientFilter",
    TAX_GURU_ACCOUNTANT_FILTER = "taxGuruAccountantFilter",
    TAX_GURU_OFFICER_FILTER = "taxGuruOfficerFilter",
    TAX_GURU_APPROVER_FILTER = "taxGuruApproverFilter",
    TAX_GURU_REGISTRATION_REQUEST_FILTER = "taxGuruRegistrationRequestFilter",
    TAX_VERSION = "lastTaxVersion",
    TAX_GURU_DASHBOARD_VIEW = "taxGuruDashboardView",
    TAX_GURU_DASHBOARD_HIDE_EMPTY = "taxGuruDashboardHideEmpty",
    TAX_GURU_DASHBOARD_SORT = "taxGuruDashboardSort",
}

export const saveNavigationFilter = (type: keyof typeof StorageKeyType, filter: Filter) => {
    localStorage.setItem(StorageKeyType[type], JSON.stringify(filter));
};

export const readNavigationFilter = (type: keyof typeof StorageKeyType): Filter | undefined => {
    const item = localStorage.getItem(StorageKeyType[type]);
    if (item) {
        return JSON.parse(item);
    }
};

export const saveSimpleValue = (type: keyof typeof StorageKeyType, value: string) => {
    localStorage.setItem(StorageKeyType[type], value);
};
export const readSimpleValue = (type: keyof typeof StorageKeyType): string | null => {
    return localStorage.getItem(StorageKeyType[type]);
};
